import ComponentInitializers from 'components/shared/ComponentInitializers/ComponentInitializers';
import RequireLoginModal from "desktop/components/require_login_modal";
import DiscussionItem from 'shared/components/discussion_item';
import { isMobile } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';
import Page from 'shared/components/page';
import Env from 'shared/env';
import { buildChannel } from 'shared/utilities/channel_builder';
import SocketAPI from 'vidio-chat';

export default class Discussion {
  constructor() {
    this.INTERVAL = 400;
    this.TIMEOUT = 8000;
    this.bindEvent = null;
    this.wait = 5000;
    this.userPresenceCount = 0;
    this.maxItem = 100;
    this.emptyClass = 'livestreaming-discussion__content--empty';
    this.isFullscreen = false;
    this.scrollBeforeTopFlag = true;
    this.scrollTopFlag = true;

    this.ui = {
      container:       '.livestreaming-discussion__container',
      content:         '.livestreaming-discussion__content',
      form:            '.livestreaming-discussion__form',
      input:           '.livestreaming-discussion__input',
      submitButton:    '.livestreaming-discussion__submit',
      submitIcon:      '.livestreaming-discussion__submit-icon',
      submitIconActive:'.livestreaming-discussion__submit-icon--active',
      emojiTable:      '.livestreaming-discussion__table-button__img',
      item:            '.livestreaming-discussion-item',
      metaCurrentUser: 'meta[name=current-username]',
      metaLanguage:    'meta[name=language]'
    };

    this.$current_username = $(this.ui.metaCurrentUser).attr('content');

    if(!isMobile()) {
      this.modal = new RequireLoginModal({ element: this.ui.input });
    }

    this.shouldRequestLatestMessages = true;
    this.wsConfig = {
      host: Env.vidioChatHost(),
      secure: Env.vidioChatSecure()
    };
  }

  init() {
    this.bindBeforeSend();
    this.bindSuccessForm();
    this.bindLiveChatScrollEvent();
    this.listenOnChangeInput();
    this.bindLoginPopupTracker();

    if(this.isWebSocketAvailable()) {
      SocketAPI.runWhenConnectionOpen(this.requestChatMessage.bind(this));
    }

    $(window).on('load', function() {
      this.bindFullscreenEvent();
    }.bind(this));

    $(document).on('visibilitychange', function() {
      this.scrollWhenWindowVisible();
    }.bind(this));
  }

  isWebSocketAvailable() {
    return 'WebSocket' in window && window.WebSocket.CLOSING === 2;
  }

  requestChatMessage() {
    SocketAPI.subscribe(buildChannel('chat', 'live', Page.id()));

    if (this.shouldRequestLatestMessages) {
      this.requestLatestMessages();
      this.shouldRequestLatestMessages = false;
    }
  }

  requestLatestMessages() {
    const token = SocketAPI.getToken()
    
    if(token == null) {
      return;
    }

    $('#comment_token').val(token.web);

    return SocketAPI.getLatestMessages(this.wsConfig, token, Page.id())
      .then(response => {
        this.loadSuccess({ comments: response.data });
      })
      .catch(err => { console.error(`Error render messages: ${err}`); });
  }

  bindLoginPopupTracker() {
    $(`${this.ui.input}, ${this.ui.emojiTable}, ${this.ui.submitButton}`).on('click', function(event) {
      if(!this.isUserLoggedIn()) {
        if (this.isEmojiTableClicked(event)) {
          event.stopPropagation();
        }

        if(isMobile()) {
          this.redirectToLogin();
        } else {
          this.modal.onClick(event);
        }
      } else {
        const livestreaming_id = Page.id();
        AhoyEvent.send("VIDIO::CHAT", { action: "click", livestreaming_id: livestreaming_id });
      }
    }.bind(this));
  }

  isUserLoggedIn() {
    return Object.keys(window.currentUser).length > 0;
  }

  redirectToLogin() {
    window.location.href = $(this.ui.input).data('url');
  }

  isEmojiTableClicked(event) {
    var className = this.ui.emojiTable.substring(1, this.ui.emojiTable.length);
    return $(event.target).hasClass(className);
  }

  isPlayerReady() {
    return window.player 
      && typeof window.player['tech'] === 'function'
      && typeof window.player['tech']['on'] === 'function'
  }

  bindFullscreenEvent() {
    this.bindEvent = setInterval(() => {
      if(this.isPlayerReady()){
        window.player.tech().on("fullscreenchange", this.checkFullscreen.bind(this));
        clearInterval(this.bindEvent);
      } else {
        console.warn('Attempting to search player...');
      }
    }, this.INTERVAL);
    setTimeout(() => { clearInterval(this.bindEvent) }, this.TIMEOUT);
  }

  _getContainerHeight() {
    return $(this.ui.container).height();
  }

  _getContainerScrollTop() {
    return $(this.ui.container).scrollTop();
  }

  bindLiveChatScrollEvent() {
    $(this.ui.container).on('scroll', function() {
      var containerScrollTop = this._getContainerScrollTop();
      var containerHeight = this._getContainerHeight();
      var contentHeight = this.height();
      var percentage = containerScrollTop / (contentHeight - containerHeight) * 100.0;

      if (contentHeight > containerHeight) {
        if (!this.scrollTopFlag) {
          if (containerScrollTop === 0) {
            this.sendAhoyEvent('top', 'scroll');
            this.scrollTopFlag = true;
          }
        }

        if (!this.scrollBeforeTopFlag) {
          if (containerScrollTop > 0 && percentage <= 25.0) {
            this.sendAhoyEvent('before-top', 'scroll');
            this.scrollBeforeTopFlag = true;
          }
        }

        if (percentage > 50.0) {
          this.scrollBeforeTopFlag = false;
          this.scrollTopFlag = false;
        }
      }
    }.bind(this));
  }

  checkFullscreen() {
    if (window.player.tech().plugin().instance().isFullscreen()) {
      if (this.isFullscreen === false) {
        this.sendAhoyEvent('open', 'fullscreen');
      }

      this.isFullscreen = true;
    } else {
      if (this.isFullscreen === true) {
        this.sendAhoyEvent('close', 'fullscreen');
      }

      this.isFullscreen = false;
    }
  }

  loadSuccess(data) {
    if (data.comments.length === 0) {
      this.addBackground();
    } else {
      var comments = data.comments;
      this.addCollection(comments);
      this.scroll();
    }
  }

  setAuthorizationHeader(xhr) {
    const token = SocketAPI.getToken() || {};
    xhr.originalEvent.detail[0].setRequestHeader('Authorization', `Bearer ${token.web}`)
  }

  bindBeforeSend() {
    $(this.ui.form).on('ajax:beforeSend', function(xhr) {
      this.setAuthorizationHeader(xhr);
      const content = $('input#comment_content[name="content"]').val();
      this.sendAhoyMessageEvent('click', content);
    }.bind(this));
  }

  bindSuccessForm() {
    $(this.ui.form).on('ajax:success', function(event, value) {
      let data = event.detail ? event.detail[0] : value;
      this.renderNewComment(data);
      this.sendAhoyMessageEvent('send', data.chatMessage.content);
    }.bind(this));
  }

  renderNewComment(data) {
    const { chatMessage } = data;

    this.removeBackground();
    this.add(chatMessage);
    this.reset();
    this.stickerify();
    this.removeOldMessages();
    this.scroll();
  }

  renderChatMessage(message) {
    this.removeBackground();
    if(this.isScrollAtBottom()) {
     this.scroll();
    }
    this.add(message);
    this.removeOldMessages();
    this.stickerify();
  }

  params(data) {
    return $.extend({ commentable_id: Page.id(), commentable_type: Page.type() }, data);
  }

  sendAhoyEvent(action, feature) {
    AhoyEvent.send('VIDIO::CHAT', {
      action: action,
      feature: feature,
      livestreaming_id: this.params().commentable_id
    });
  }

  sendAhoyMessageEvent(action, content) {
    const variant = Number($('footer.livestreaming-discussion__footer').attr('data-variant'));

    AhoyEvent.send('VIDIO::CHAT', {
      action: action,
      content: content,
      livestreaming_id: this.params().commentable_id,
      variant: variant
    });
  }

  removeOldMessages() {
    var $item = $(this.ui.item);
    var currentTotalItem = $item.length;

    if (currentTotalItem > this.maxItem) {
      var delta = currentTotalItem - this.maxItem;
      $item.slice(0, delta).remove();
    }
  }

  addBackground() {
    $(this.ui.content).addClass(this.emptyClass);
  }

  removeBackground() {
    $(this.ui.content).removeClass(this.emptyClass);
  }

  add(comment) {
    if ($(`${this.ui.item}[data-id="${comment.id}"]`).length === 0) {
      const item = DiscussionItem.new(comment, this.$current_username);
      $(this.ui.content).append(item.html);
    }
  }

  addCollection(comments) {
    for (var i in comments) {
      var comment = comments[i];
      this.add(comment);
    }
    this.removeOldMessages();
    this.stickerify();
  }

  reset() {
    $(this.ui.input).val('');
  }

  height() {
    return $(this.ui.content).height();
  }

  scroll() {
    $(this.ui.container).animate({ scrollTop: this.height() });
  }

  scrollWhenWindowVisible() {
    if (! document.hidden) { this.scroll(); }
  }

  isScrollAtBottom() {
    var container = $(this.ui.container);
    return (container.prop('offsetHeight') + container.prop('scrollTop')) == container.prop('scrollHeight');
  }

  stickerify() {
    new ComponentInitializers();
  }

  windowReload() {
    window.location.reload();
  }

  listenOnChangeInput() {
    var $input = $(this.ui.input);
    var $submitIcon = $(this.ui.submitIcon);
    var $submitIconActive = $(this.ui.submitIconActive);

    $input.keyup(function() {
      if($input.val().length > 0 && $submitIconActive.length === 0) {
        $submitIcon.attr('class', 'livestreaming-discussion__submit-icon livestreaming-discussion__submit-icon--active');
      } else if ($input.val().length === 0) {
        $submitIcon.attr('class', 'livestreaming-discussion__submit-icon');
      }
    });
  }
}

